module.exports = __webpack_public_path__ + "img/pigai-info.943f7474.png";